import { gql } from "@apollo/client";

export const UPDATE_PROGRAMMING_STRUCTURE = gql`
  mutation updateProgrammingStructure(
    $scenarioId: ID!
    $originId: ID
    $input: ProgrammingStructureCrudInput!
  ) {
    cube(scenarioId: $scenarioId, originId: $originId) {
      programmingStructuresCrud(input: $input) {
        userCanSkipValidations
        skippedValidations
        commited
        payload {
          updates {
            structure {
              id
            }
            validationErrors {
              __typename
              ... on ProgrammingStructureValidation {
                id
                code
                reason
              }
              ... on ProgrammingStructureDuplicateCodeSubject {
                id
                code
                subjectCodes
                reason
              }
              ... on ProgrammingStructureDependencyCodeNotInStructure {
                id
                programmingStructurePartCode
                dependencyCode
                reason
              }
              ... on ProgrammingStructureStageNotFound {
                programmingStructureStageId
                programmingStructurePartCode
                reason
              }
            }
          }
        }
      }
    }
  }
`;
